import { FC, useMemo } from "react";
import { BannerData } from "./BaMaTypes";

import defaultImage from "../../../assets/images/defaultCover/defaultCoverProduct.png";
import CustomButton from "../../kits/custom-button/CustomButton";
import { TrashIcon } from "../../kits/Icons/Icons";
import ColorSchema from "../../../assets/kits/colors";
import { pathMaker } from "../../../utilities/helperFunctions";

interface BannerCardProps {
  banner: BannerData;
  index: number;
  deleteFunction: React.MouseEventHandler<HTMLButtonElement>;
}

const BannerCard: FC<BannerCardProps> = ({ banner, index, deleteFunction }) => {
  const items = useMemo(
    () =>
      Object.keys(banner).reduce<{ label: string; value: string }[]>(
        (total, key) => {
          if (key === "place") {
            total.push({
              label: "جایگاه بنر",
              value: banner[key],
            });
          }
          if (key === "type") {
            total.push({
              label: "نوع بنر",
              value: banner[key],
            });
          }
          if (key === "order") {
            total.push({
              label: "ترتیب",
              value: banner[key],
            });
          }
          return total;
        },
        []
      ),
    [banner]
  );

  return (
    <div className="banner-card row justify-content-center align-items-center mr-t-24">
      {items.map((item, ind) => (
        <div
          className="banner-card-item col p-0"
          key={`banner-card-${index}-${ind}`}
        >
          <div className="banner-card-item-label title-h5-b pd-32">
            {item.label}
          </div>
          <div className="banner-card-item-value txt-t2-m pd-32">
            {item.value}
          </div>
        </div>
      ))}
      <div
        className="banner-card-item col p-0"
        key={`banner-card-link-${index}`}
      >
        <div className="banner-card-item-label title-h5-b pd-32">URL</div>
        <div className="banner-card-item-value txt-t2-m pd-32">
          <a href={banner.link} rel="noreferrer" target="_blank">{banner.link}</a>
        </div>
      </div>
      <div
        className="banner-card-item col p-0"
        key={`banner-card-image-${index}`}
      >
        <div className="banner-card-item-label title-h5-b pd-32">نمایش عکس</div>
        <div className="banner-card-item-value txt-t2-m pd-32">
          <img
            src={banner.image === "" ? defaultImage : pathMaker(banner.image)}
            alt=""
            style={{ height: 100 }}
          />
        </div>
      </div>
      <div className="banner-card-item col p-0" key={`banner-card-operations`}>
        <div className="banner-card-item-label title-h5-b pd-32">عملیات‌ها</div>
        <div className="banner-card-item-value txt-t2-m pd-32">
          <CustomButton buttonStyle="text" onClick={deleteFunction}>
            <TrashIcon color={ColorSchema.white_0} width={30} height={30} />
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default BannerCard;
